import React from "react";
import PT from "prop-types";

import "./search-icon.m.css";

export default function SearchIcon({ onClick, className, height = 20, width = 18, color = "#FFF" }) {
  return (
    <div onClick={onClick} styleName={className}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 20">
        <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.44" transform="translate(1 1)">
          <ellipse cx="6.434" cy="6.635" rx="6.154" ry="6.346" />
          <path strokeLinecap="square" d="M10.35 11.827l5.452 5.85" />
        </g>
      </svg>
    </div>
  );
}

SearchIcon.propTypes = {
  onClick: PT.func,
  className: PT.string,
  width: PT.number,
  height: PT.number,
  color: PT.string
};
